import { Stack, styled } from '@mui/material';
import DismissibleNotification from './DismissibleNotification';
import { useNotifierContext } from './NotifierContext';

const StyledStack = styled(Stack)(() => ({
  position: 'fixed',
  zIndex: 1200,
  top: 64,
  width: '100%'
}));

const NotificationsViewer = () => {
  const { notifications, removeNotification } = useNotifierContext();
  return (
    <StyledStack rowGap={1} direction="column">
      {notifications.map((notification) => (
        <DismissibleNotification
          key={notification.id}
          notification={notification}
          onDismiss={() => removeNotification(notification.id ? notification.id : -1)}
        />
      ))}
    </StyledStack>
  );
};

export default NotificationsViewer;
